import { get } from '../HttpService';


export class ContactService {
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/contacts/`, queryData, config);
    };
};